import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { ActiveLink } from '@/ui/index';
import { Support } from '@/icons/index';

import styles from './CheckoutHeader.module.scss';

const CheckoutHeader = () => {
  const route = useRouter();
  return (
    <div
      className={styles.wrapper}
      itemScope
      itemType='https://schema.org/Property'
    >
      <div className={`wrapper ${styles.header}`}>
        <ActiveLink href={'/'}>
          <a className={styles.logo}>
            <Image
              src={'/data/red-logo.svg'}
              alt={'Backcell'}
              title={'Backcell'}
              loading='lazy'
              layout='fill'
            />
          </a>
        </ActiveLink>
        <ActiveLink
          href={
            route.pathname.startsWith('/business')
              ? '/business/support'
              : '/support'
          }
        >
          <a className={styles.support} title='Bakcell' aria-label='Bakcell'>
            <Support width={24} />
            Support
          </a>
        </ActiveLink>
      </div>
    </div>
  );
};

export default CheckoutHeader;
